<!--
 * @Author: lishiqiao
 * @Date: 2022-03-01 10:34:12
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-19 15:58:50
-->
<template>
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div class="type-activite">动保进出存</div>
      </div>
      <div class="page-list">
        <!-- 搜索栏 -->
        <div class="page-search-content" ref="searchBox">
          <div class="page-big-box">
            <div class="page-search-item">
              <label>养殖场&nbsp;:</label>
              <el-select v-model="params.params.baseId" @change="selectBase" filterable placeholder="请选择养殖场">
                <el-option label="全部养殖场" value=""></el-option>
                <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>仓库&nbsp;:</label>
              <el-select v-model="params.params.groupId" filterable placeholder="请选择仓库">
                <el-option label="全部仓库" value=""></el-option>
                <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="page-search-item">
              <label>动保名称&nbsp;:</label>
              <el-select v-model="params.params.drugId" filterable placeholder="请选择动保">
                <el-option label="全部动保" value=""></el-option>
                <el-option v-for="item in drugList" :key="item.drugId" :label="item.drugName" :value="item.drugId">
                </el-option>
              </el-select>
            </div>
            <!-- 选择日期年月日 -->
            <div class="page-search-date">
              <div class="page-search-item date-selection-box">
                <span @click="params.params.type = 'Y'" :class="[params.params.type == 'Y' ? 'active-date' : '']">年</span>
                <span @click="params.params.type = 'M'" :class="[params.params.type == 'M' ? 'active-date' : '']">月</span>
                <span @click="params.params.type = 'D'" :class="[params.params.type == 'D' ? 'active-date' : '']">日</span>
              </div>
              <div class="page-search-item" v-show="params.params.type === 'Y'">
                <label>年份&nbsp;:</label>
                <el-date-picker value-format="yyyy" :clearable="false" v-model="params.params.year"
                  :picker-options="pickerOptions" type="year" placeholder="请选择年份">
                </el-date-picker>
              </div>
              <div class="page-search-item" v-show="params.params.type === 'M'">
                <label>月份区间&nbsp;:</label>
                <el-date-picker v-model="monthRange" :clearable="false" :picker-options="pickerOptions"
                  value-format="yyyy-MM" @change="monthChange" type="monthrange" range-separator="~"
                  start-placeholder="开始月份" end-placeholder="结束月份">
                  >
                </el-date-picker>
              </div>
              <div class="page-search-item" v-show="params.params.type === 'D'">
                <label>日期区间&nbsp;:</label>
                <el-date-picker v-model="dateRange" :clearable="false" :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd" @change="dateChange" type="daterange" range-separator="~"
                  start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
            <div class="page-search-item">
              <label>查询合计&nbsp;:</label>
              <el-checkbox v-model="params.params.total"></el-checkbox>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="page-search-btn">
            <div class="search-btn" @click="search">查询</div>
            <div class="reset-btn" @click="reset">重置</div>
            <div class="search-close-btn">
              <div @click="PageSearchClose" v-if="PageDisplay">
                <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
              </div>
              <div @click="PageSearchOn" v-else>
                <span>展开</span><i class="iconfont icon-List-Collapse"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 内容 -->
        <div class="page-list-content">
          <!-- 列表 -->
          <div class="page-list-title">
            <div><i class="title-icon"></i>动保进出存</div>
            <div>单位 : {{ unitName }}</div>
            <div></div>
            <div>
              <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
                <span class="el-dropdown-link">
                  冻结列<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="y">冻结至"{{
                    fixedColumn.label
                  }}"列</el-dropdown-item>
                  <el-dropdown-item command="n">取消冻结</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span class="action-button" @click="exportTable">
                <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
              </span>
            </div>
          </div>
          <!-- 表格 -->
          <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%"
            :row-class-name="tableRowClassName" @header-click="handleClick">
            <el-table-column :fixed="fixedColumnList[0].fixed"
              :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''" prop="baseName" label="养殖场">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[1].fixed"
              :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''" prop="date" label="时间"> </el-table-column>
            <el-table-column :fixed="fixedColumnList[2].fixed"
              :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''" prop="groupName" label="仓库">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[3].fixed"
              :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''" prop="drugName" label="动保名称">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[4].fixed"
              :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''" prop="specification" label="规格">
            </el-table-column>
            <el-table-column :fixed="fixedColumnList[5].fixed"
              :class-name="fixedColumnList[5].selected ? 'cellSelected' : ''" prop="specificationUnit" label="计量单位">
            </el-table-column>
            <el-table-column prop="startNumber" label="期初数量">
            </el-table-column>
            <el-table-column prop="startMoney" label="期初金额">
            </el-table-column>
            <el-table-column prop="buyNumber" label="入库数量">
            </el-table-column>
            <el-table-column prop="buyMoney" label="入库金额">
            </el-table-column>
            <el-table-column prop="outNumber" label="出库数量">
            </el-table-column>
            <el-table-column prop="outMoney" label="出库金额">
            </el-table-column>
            <el-table-column prop="inventNumber" label="盈亏数量">
            </el-table-column>
            <el-table-column prop="inventMoney" label="盈亏金额">
            </el-table-column>
            <el-table-column prop="stockNumber" label="期末数量">
            </el-table-column>
            <el-table-column prop="stockMoney" label="期末数金额">
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="uyu-pagination">
            <MyPagination @change="handleCurrentChange($event)" @changeSizes="handleSizeChange($event)"
              :sizes="[13, 26, 39, 50, 100, 200]" :pageNo.sync="params.currPage" :pageSize.sync="params.pageSize"
              :totalCount="totalCount">
            </MyPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyPagination from "@/components/pc/my-pagination.vue";
import service from "./ym-drug-service";
import Page from "@/utils/methods/page";
export default {
  name: "drug-use",
  data() {
    return {
      unitName: "", // 单位名称
      monthRange: [],
      dateRange: [
        this.$moment().subtract(1, "months").format("YYYY-MM-DD"),
        this.$moment().format("YYYY-MM-DD"),
      ],
      PageDisplay: true,
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "date",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "drugName",
          fixed: false,
          selected: false
        },
        {
          prop: "specification",
          fixed: false,
          selected: false
        },
        {
          prop: "specificationUnit",
          fixed: false,
          selected: false
        },
      ],
      params: {
        currPage: 1, // 当前页
        pageSize: 13, // 每页条数
        orderBy: "desc",
        orderByName: "date",
        params: {
          baseId: "",
          groupId: "",
          startDate: "", // 开始时间(如果是日则2019-01-01)
          endDate: "", // 结束时间
          type: "Y", // Y表示年,M表示按月查询,D表示近日查询
          year: localStorage.getItem("m-year") ? localStorage.getItem("m-year") : this.$moment().year().toString(), // 如果type为Y则year不能为空,如果type不为Y year一定要为null
          drugId: "",
          yzcTotal: false, // true: 查询某药品在基地下的进出存数据
          total: false,
        },
      },
      totalCount: 0, // 总条数
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      baseList: [], // 基地列表
      groupList: [], // 分组列表
      drugList: [], // 动保名称
      exportParams: {}, // 导出参数
      tableData: [],
    };
  },
  components: { MyPagination },
  created() {
    this.tableHeight = window.innerHeight - 450;
    this.unitName = localStorage.getItem("orgName");
    this.getBaseListsByUser(); // 获取基地列表
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    // 选择月
    monthChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val[0];
      this.params.params.endDate = val[1];
    },

    // 选择日期
    dateChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val[0];
      this.params.params.endDate = val[1];
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-03 09:44:06
     * @description: 获取用户权限基地
     * @param {*}
     */
    getBaseListsByUser() {
      service
        .getBaseListsByUser()
        .then((res) => {
          if (res.code == "0000") {
            this.baseList = res.data;
            if (this.baseList && this.baseList.length) {
              this.params.params.baseId = this.baseList[0].id;
              this.getPageList(); // 获取分页
              this.getStoreHouseList(this.params.params.baseId, ""); // 获取仓库
              this.getMedicinalsList(this.params.params.baseId); // 获取动保名称
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-03 11:03:48
     * @description: 选择基地
     * @param {*}
     */
    selectBase(event) {
      this.params.params.groupId = "";
      this.groupList = [];
      this.params.params.drugId = "";
      this.drugList = [];
      if (!event) {
        return;
      }
      this.getStoreHouseList(event, ""); // 根据基地id获取区域分组
      this.getMedicinalsList(event); // 获取动保名称
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-03 18:22:34
     * @description: 根据基地id获取分组列表(含角色权限控制) 获取仓库列表
     * @param {*} baseId
     * @param {*} groupFlag 0:区域，1：总仓，空：区域和总仓
     */
    getStoreHouseList(baseId, groupFlag) {
      service
        .getInOutStoreHouseList(baseId, groupFlag)
        .then((res) => {
          if (res.code == "0000") {
            this.groupList = res.data;
          } else {
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-03 18:27:48
     * @description: 根据基地id获取动保名称列表
     * @param {*} baseId
     */
    getMedicinalsList(baseId) {
      service
        .getMedicinalsList(baseId)
        .then((res) => {
          if (res.code == "0000") {
            this.drugList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 查询
    search() {
      this.getPageList();
    },

    // 初始化时间
    initTime() {
      this.params.params.year = null;
      this.params.params.startDate = null;
      this.params.params.endDate = null;
      this.monthRange = [];
      this.dateRange = [];
      if (this.params.params.type == "Y") {
        this.params.params.year = localStorage.getItem("m-year") ? localStorage.getItem("m-year") : this.$moment().year().toString();
      }
      if (this.params.params.type == "M") {
        this.params.params.startDate = this.$moment().format("YYYY-MM");
        this.params.params.endDate = this.$moment().format("YYYY-MM");
        this.monthRange.push(this.params.params.startDate);
        this.monthRange.push(this.params.params.endDate);
      }
      if (this.params.params.type == "D") {
        this.params.params.startDate = this.$moment().format("YYYY-MM-DD");
        this.params.params.endDate = this.$moment().format("YYYY-MM-DD");
        this.dateRange.push(this.params.params.startDate);
        this.dateRange.push(this.params.params.endDate);
      }
    },

    // 重置
    reset() {
      this.params.params.groupId = "";
      this.params.params.drugId = "";
      this.params.params.total = false;
      this.initTime();
      this.getPageList();
    },

    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },

    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },

    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.baseName === "合计") {
        return "heji-row";
      }
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 14:17:40
     * @description: 分页
     * @param {*}
     */
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      service
        .getDrugInOutPageList(this.params)
        .then((res) => {
          if (res.code == "0000") {
            this.params.currPage = res.data.pageNumber;
            this.params.pageSize = res.data.pageSize;
            this.totalCount = res.data.totalCount;
            this.tableData = res.data.list;
            this.exportParams = JSON.parse(JSON.stringify(this.params));
          } else {
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error(err);
          loading.close();
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-01 14:17:53
     * @description: 导出
     * @param {*}
     */
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          const param = {
            titleName: "动保进出存",
            sheetName: "列表",
            fileName: "动保进出存",
            param: this.exportParams,
          };
          service
            .exportDrugInOutData(param)
            .then((res) => { })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch((err) => { });
    },
    /**
     * @Author: lishiqiao
     * @Date: 2022-03-07 10:07:26
     * @description: 切换单前页
     * @param {*} event
     */
    handleCurrentChange(event) {
      this.params.currPage = event;
      this.getPageList();
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-07 10:14:06
     * @description: 改变当前分页总数
     * @param {*} event
     */
    handleSizeChange(event) {
      this.params.pageSize = event;
      this.params.currPage = 1;
      this.getPageList();
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  watch: {
    // 监听type年月日变化
    "params.params.type"(val) {
      this.initTime();
      this.getPageList();
    },
  },
};
</script>

<style lang="less" scoped></style>